import { FileValidatorModel } from '@/types/common';

/* eslint-disable no-case-declarations */
const checkDigit = function (inn: string | number, coefficients: number[]) {
  let n = 0;
  for (const i in coefficients) {
    const digits = inn.toString().split("");
    n += coefficients[i] * +digits[i];
  }
  return parseInt((n % 11 % 10).toString());
};

export const validateInn = function(inn: string | number) {
	let result = false;
	if (typeof inn === 'number') {
		inn = inn.toString();
	} else if (typeof inn !== 'string') {
		inn = '';
	}
	
	switch (inn.length) {
		case 10:
			const n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
			if (n10 === parseInt(inn[9])) result = true;
			break;
		case 12:
			const n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
			const n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
			if ((n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]))) {
				result = true;
			}
			break;
		default: 
			return false
	}

	return result;
}

export const validateKpp = function(kpp: string | number) {
	let result = false;
	if (typeof kpp === 'number') {
		kpp = kpp.toString();
	} else if (typeof kpp !== 'string') {
		kpp = '';
	}

	if (kpp.length !== 9) {
		return false;
	} else if (!/^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(kpp)) {
		result = false;
	} else {
		result = true;
	}

	return result;
}

export const validateOgrn = function(ogrn: string | number) {
	let result = false;
	if (typeof ogrn === 'number') {
		ogrn = ogrn.toString();
	} else if (typeof ogrn !== 'string') {
		ogrn = '';
	}

	if (ogrn.length !== 13 && ogrn.length !== 15) {
		return false;
	} else {
		
		const n13 = parseInt((parseInt(ogrn.slice(0, -1)) % 11).toString().slice(-1));
		const n15 = parseInt((parseInt(ogrn.slice(0, -1)) % 13).toString().slice(-1));

		if (n13 === parseInt(ogrn[12])) 
		{
			result = true;
		} 
		else if(n15 === parseInt(ogrn[14])) {
			result = true;
		}
		else 
		{
			result = false;
		}
	}
	return result;
}

export const validateFilesExt = function(files: File[], extensions: string[]): FileValidatorModel {
	const valid = [];
	const invalid = [];

	for (let i = 0; i < files.length; i++) {

		const name = files[i]?.name;
		const matchArray = name.match(/\.([^.]+)$/);
		const ext = matchArray && matchArray[1].toLowerCase() || '';

		if (extensions.indexOf(ext) > -1) {
			valid.push(files[i]);
		}
		else {
			invalid.push(files[i]);
		}
	}

	return {
		valid,
		invalid
	};
}

export const validateFiles = function(files: File[], extensions: string[], maxFileSizeForUploading?: number): FileValidatorModel {
	const valid = [];
	const invalid = [];

	for (let i = 0; i < files.length; i++) {
		if (maxFileSizeForUploading && files[i].size > maxFileSizeForUploading) continue;

		const name = files[i]?.name;
		const matchArray = name.match(/\.([^.]+)$/);
		const ext = matchArray && matchArray[1].toLowerCase() || '';

		if (extensions.indexOf(ext) > -1) {
			valid.push(files[i]);
		}
		else {
			invalid.push(files[i]);
		}
	}

	return {
		valid,
		invalid
	};
}

/* eslint-enable  no-case-declarations */